var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletNewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 63,
    viewBox: "0 0 75 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27686_4144)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27686_4144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 75,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 0H0V62.5H75V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27686_4144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4531 7.44043H20.3281C17.9119 7.44043 15.9531 9.39918 15.9531 11.8154V31.8154C15.9531 34.2317 17.9119 36.1904 20.3281 36.1904H58.4531C60.8694 36.1904 62.8281 34.2317 62.8281 31.8154V11.8154C62.8281 9.39918 60.8694 7.44043 58.4531 7.44043Z",
    fill: "url(#paint0_linear_27686_4144)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M18.4526 11.1899C20.1194 8.68987 23.0359 7.6482 27.2026 8.06487C25.9526 10.9815 23.0359 12.0232 18.4526 11.1899Z",
    fill: "#6BD36A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M40.3281 26.8154C43.0895 26.8154 45.3281 24.5768 45.3281 21.8154C45.3281 19.054 43.0895 16.8154 40.3281 16.8154C37.5667 16.8154 35.3281 19.054 35.3281 21.8154C35.3281 24.5768 37.5667 26.8154 40.3281 26.8154Z",
    fill: "#C7FFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3271 24.3164C41.7079 24.3164 42.8271 23.1972 42.8271 21.8164C42.8271 20.4356 41.7079 19.3164 40.3271 19.3164C38.9464 19.3164 37.8271 20.4356 37.8271 21.8164C37.8271 23.1972 38.9464 24.3164 40.3271 24.3164Z",
    fill: "#66C86A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M55.6401 11.8145H51.8901C51.3723 11.8145 50.9526 12.2342 50.9526 12.752V13.377C50.9526 13.8947 51.3723 14.3145 51.8901 14.3145H55.6401C56.1579 14.3145 56.5776 13.8947 56.5776 13.377V12.752C56.5776 12.2342 56.1579 11.8145 55.6401 11.8145Z",
    fill: "#58C05A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3276 17.4404H14.0776C9.59032 17.4404 5.95264 21.0781 5.95264 25.5654V46.8154C5.95264 51.3028 9.59032 54.9404 14.0776 54.9404H60.3276C64.815 54.9404 68.4526 51.3028 68.4526 46.8154V25.5654C68.4526 21.0781 64.815 17.4404 60.3276 17.4404Z",
    fill: "url(#paint1_linear_27686_4144)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M9.54639 19.3153C20.5056 15.546 27.589 14.8726 37.6714 17.3855C50.384 20.3173 58.85 22.5945 67.179 20.9192L69.2339 26.1806C52.576 28.6935 31.5343 28.6935 6.10889 26.1806V23.2996L9.54639 19.3153Z",
    fill: "url(#paint2_linear_27686_4144)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    filter: "url(#filter0_d_27686_4144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95264 39.3154C8.45264 45.5654 11.5776 49.1071 15.3276 49.9404H59.0776C62.8276 49.5237 65.9526 45.9821 68.4526 39.3154V33.6904C45.5359 37.4404 24.7026 37.2321 5.95264 33.0654V39.3154Z",
    fill: "#6155D7"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M65.3271 28.0654H53.4521C51.3811 28.0654 49.7021 29.7443 49.7021 31.8154V33.6904C49.7021 35.7615 51.3811 37.4404 53.4521 37.4404H65.3271C67.3982 37.4404 69.0771 35.7615 69.0771 33.6904V31.8154C69.0771 29.7443 67.3982 28.0654 65.3271 28.0654Z",
    fill: "#8F80FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7026 36.502C56.7737 36.502 58.4526 34.823 58.4526 32.752C58.4526 30.6809 56.7737 29.002 54.7026 29.002C52.6315 29.002 50.9526 30.6809 50.9526 32.752C50.9526 34.823 52.6315 36.502 54.7026 36.502Z",
    fill: "url(#paint3_radial_27686_4144)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M53.4526 32.8145C54.1775 32.8145 54.7651 32.2268 54.7651 31.502C54.7651 30.7771 54.1775 30.1895 53.4526 30.1895C52.7278 30.1895 52.1401 30.7771 52.1401 31.502C52.1401 32.2268 52.7278 32.8145 53.4526 32.8145Z",
    fill: "#C8F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4526 23.0654H17.2026C14.096 23.0654 11.5776 25.5839 11.5776 28.6904V43.0654C11.5776 46.172 14.096 48.6904 17.2026 48.6904H43.4526C46.5592 48.6904 49.0776 46.172 49.0776 43.0654V28.6904C49.0776 25.5839 46.5592 23.0654 43.4526 23.0654Z",
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 0.3125
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M14.7021 19.3154C16.3688 18.4821 18.2438 18.4821 20.3271 19.3154C18.2438 20.5654 16.3688 20.5654 14.7021 19.3154Z",
    fill: "#BDB1FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_27686_4144",
    x: 2.20264,
    y: 30.2529,
    width: 70,
    height: 24.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.9375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27686_4144"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27686_4144",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27686_4144",
    x1: 15.9531,
    y1: 7.44043,
    x2: 41.5797,
    y2: 49.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76E27A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FC84B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27686_4144",
    x1: 5.95264,
    y1: 17.4404,
    x2: 39.0409,
    y2: 72.5875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A89BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B6BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27686_4144",
    x1: 6.10889,
    y1: 15.8778,
    x2: 6.10889,
    y2: 28.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC9FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_27686_4144",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(275.953 254.002) scale(600)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7EE1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB6D6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27686_4144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 62.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletNewIcon);
export default __webpack_public_path__ + "static/media/walletNewIcon.40fdb10b988f5968d1c2fbe698351984.svg";
export { ForwardRef as ReactComponent };